import { ILocation } from './TLocation';
import { VisitDtoModelType } from '../store/mst/models';

export type TVisit = PlanningApi.VisitDto;
export type TVisitLocation = PlanningApi.VisitLocationDto;
export type TVisitPatch = PlanningApi.PatchVisitDto;
export type TVisitCreate = PlanningApi.AddOrderDto;

export type TVisitTimeWindowCreate = PlanningApi.AddVisitTimeWindowDto;
export type TVisitTimeWindow = PlanningApi.VisitTimeWindowDto;

// eslint-disable-next-line import/prefer-default-export
export enum TVisitLocationStatus {
  INVALID = 1,
  VALIDATED = 2,
  GEOCODING = 3,
}

export interface IVisitActiveLocation extends ILocation {
  locationStatusId: number;
}

export interface IVisit extends VisitDtoModelType {}

export interface IVisitForm {
  visible: boolean;
  visitId?: number;
}

export enum VisitStatus {
  ARRIVED = 'arrived',
  ON_THE_WAY = 'on_the_way',
  DEPARTED = 'departed',
  COMPLETED = 'done',
  SKIPPED = 'skipped',

}
